module.exports = __webpack_public_path__ + "img/logo.9f85ab82.png";